import { render } from "./place-input.vue?vue&type=template&id=28a3eeb1"
import script from "../components-implementation/place-input.js?vue&type=script&lang=js"
export * from "../components-implementation/place-input.js?vue&type=script&lang=js"
script.render = render

export default script